import { NetworkInstructionDispatcher } from "./Variable";
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { FirmInstructionHistoryCollectionModel } from "../../../../Wrap/Models/Models/Company/FirmInstructionHistoryCollectionModel";
import { BaseStore } from "../../../../react-core/Flux/BaseStore";

export interface NetworkInstructionStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: FirmInstructionHistoryCollectionModel;
}

export class NetworkInstructionStoreStatic extends BaseStore<NetworkInstructionStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(NetworkInstructionDispatcher, (actionData) =>
            this.onNetworkInstructionStoreResponse(actionData)
        );
    }

    public getLastResult(): NetworkInstructionStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): NetworkInstructionStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onNetworkInstructionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
